import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { User } from '../../../../shared/models/user';
import { UsersService } from '../../../../core/services/users.service';
import { AlertType } from '../../../../shared/models/alertType';
import { showAlertDialog } from '../../../../shared/helpers/showAlertDialog';
import { RolesService } from '../../../../core/services/roles.service';
import { Role } from '../../../../shared/models/role';

@Component({
  selector: 'app-user-dialog',
  imports: [MatIconModule, MatDialogModule, CommonModule, ReactiveFormsModule],
  templateUrl: './user-dialog.component.html',
  styleUrl: './user-dialog.component.scss'
})
export class UserDialogComponent implements OnInit {
  userForm: FormGroup;
  nomeFocused: boolean = false;
  emailFocused: boolean = false;
  cargoFocused: boolean = false;
  cargos: Role[] = [];

  constructor(
    public dialogRef: MatDialogRef<UserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { edit: boolean, user?: User },
    private fb: FormBuilder,
    private usersService: UsersService, 
    private rolesService: RolesService,
    private dialog: MatDialog,
  ) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-dialog-container';
    this.dialogRef.updateSize('480px');

    this.userForm = this.fb.group({
      nomeCompleto: ['', { validators: [Validators.required], }],
      email: ['', {
        validators: [Validators.required, Validators.email],
      }],
      roleId: [undefined, { validators: [Validators.required], }],
    });

    if (this.data.edit && this.data.user) {
      this.userForm.patchValue({
        nomeCompleto: this.data.user.name,
        email: this.data.user.email,
        roleId: this.data.user.roleId,
      });
    }
  }

  ngOnInit(): void {
    this.rolesService.getRoles({ page: 1, pageSize: 1000, sort: 'normal' }).subscribe((roles) => {
      this.cargos = roles.items;
    });
  }

  onClienteSelected(clienteId: number) {
    this.userForm.patchValue({ clienteId: clienteId });
  }

  onClearClienteSelected() {
    this.userForm.patchValue({ clienteId: null });
  }

  onSubmit() {
    let user: User;

    if (this.data.edit && this.data.user) {
      user = {
        ...this.data.user,
        name: this.userForm.value.nomeCompleto,
        email: this.userForm.value.email,
        roleId: this.userForm.value.roleId,
      };
      this.usersService.updateUser(user.id!, user).subscribe(() => {
        const alertDialogRef = showAlertDialog(this.dialog, AlertType.Success, 'Sucesso!', 'Usuário atualizado com sucesso!');
        alertDialogRef.afterClosed().subscribe(() => {
          this.dialogRef.close(true);
        });
      });
    } else {
      user = {
        email: this.userForm.value.email,
        name: this.userForm.value.nomeCompleto,
        roleId: this.userForm.value.roleId,
        passwordExpired: false,
        active: true
      };
      this.usersService.createPanelUser(user).subscribe((res) => {
        if (res.emailSent) {
          showAlertDialog(this.dialog, AlertType.Success, 'Sucesso!', 'Usuário adicionado com sucesso!');
        } else {
          showAlertDialog(this.dialog, AlertType.Success, 'Sucesso!', 'Usuário cadastrado com sucesso, porém não foi possível enviar o e-mail de boas-vindas.');
        }
        this.dialogRef.close(true);
      });
    }
  }

  preventEnterSubmit(event: Event): void {
    if (event instanceof KeyboardEvent && event.key === 'Enter') {
      event.preventDefault();
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
